import { type UnknownObject } from '@customTypes/general';

export const isObject = <T>(obj: T | UnknownObject): obj is UnknownObject =>
  obj !== null && typeof obj === 'object' && !Array.isArray(obj);

export const isObjectAndIsEmpty = <T>(obj: T | UnknownObject): obj is UnknownObject =>
  isObject(obj) && Object.entries(obj).length < 1;

export const isObjectAndIsNotEmpty = <T>(obj: T | UnknownObject): obj is UnknownObject =>
  isObject(obj) && Object.entries(obj).length >= 1;

export const hasProp = <T>(obj: T, prop: PropertyKey): boolean => {
  if (isObjectAndIsEmpty(obj)) {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(obj, prop);
};
